/**
 * Store helper for Vue 2.7 and the composition API.
 */
// @ts-ignore
const useStore = () => {
    // @ts-ignore
    return window.marque.ui.app.$store;
};
export { useStore };
